import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SecureAxiosClient from '../../auth/secure_axios';
import getConfig from '../../config';

class AccountSettings extends Component {

    constructor(props) {
        super(props);
        //TODO: user_id is hardcoded to luigi, update after user setup from firebase to luigi is complete
        this.state = {
            name: "",
            image_url: "",
            handle: "",
            bio: "",
            isSignupRedirect: false
        };

        this.updateUser = this.updateUser.bind(this);
        this.handleNameUpdate = this.handleNameUpdate.bind(this);
        this.handleUrlUpdate = this.handleUrlUpdate.bind(this);
        this.handleUsernameUpdate = this.handleUsernameUpdate.bind(this);
        this.handleBioUpdate = this.handleBioUpdate.bind(this);
    }

    componentDidMount() {
        const query = new URLSearchParams(window.location.search);
        const isRedirect = query.get('signup-redirect');
        if (isRedirect) {
            this.setState({ isSignupRedirect: isRedirect });
        }
        
    }

    handleNameUpdate(event) {
        this.setState({ name: event.target.value });
    }

    handleUrlUpdate(event) {
        this.setState({ image_url: event.target.value });
    }

    handleUsernameUpdate(event) {
        this.setState({ handle: event.target.value });
    }

    handleBioUpdate(event) {
        this.setState({ bio: event.target.value });
    }

    updateUser(e) {
        e.preventDefault()
        const self = this;
        const { name, image_url, handle, bio } = this.state;
        console.log("User Data:", { name, image_url, handle, bio });
        const config = getConfig();
        const updateUserUrl = `${config.luigi.domain}${config.luigi.services.user}`;
        console.log("Update User url:", updateUserUrl);
        new SecureAxiosClient(true).get(
            updateUserUrl,
            { name, image_url, handle, bio },
            (responseCode, responseData) => {
                console.log("User Updated", responseData);
                console.log("Self: ", self);
                console.log("this: ", this);
                //TODO: Update redux data and show updated message
                if(self.state.isSignupRedirect) {
                    self.props.history.push("");
                }
            }
        )
    }

    render() {
        //TODO: Pre populate name and Image
        return (
            <div className="thread-post-form">
                {
                    this.state.isSignupRedirect ?
                        <h1>Almost Done! Let's setup your profile page.</h1>
                        :
                        <h1>Account Settings</h1>
                }
                <form id='thread-info-form'>
                    <input type="text" placeholder="Name" value={this.state.title} onChange={this.handleNameUpdate} /> <br />
                    <input type="text" placeholder="Avatar" value={this.state.url} onChange={this.handleUrlUpdate} />
                    <input type="text" placeholder="Username" value={this.state.url} onChange={this.handleUrlUpdate} />
                    <input type="text" placeholder="Bio" value={this.state.url} onChange={this.handleUrlUpdate} />
                </form>
                <div className='action-buttons'>
                    <form onSubmit={this.updateUser} id='thread-button'>
                        <input type="submit" value="Update" />
                    </form>
                </div>
            </div>
        )
    }
}

AccountSettings.propTypes = {
    user: PropTypes.object
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    };
};

const mapDispatchToProps = dispatch => {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);
